import React from "react";
import { TableOutlined, AlertOutlined, MessageOutlined, HistoryOutlined, PieChartOutlined } from "@ant-design/icons";
import QuickAccessWidget from "../common/QuickAccessWidget";

const UldQuickAccessWidget = (props) => {
    const items = [
        {
            label: "ULD台账",
            path: "/uld-management",
            icon: <TableOutlined />,
            primary: true,
        },
        {
            label: "库存预警",
            path: "/uld-stock-alert",
            icon: <AlertOutlined />,
            primary: true,
        },
        {
            label: "UCM报文",
            path: "/ucm-management",
            icon: <MessageOutlined />,
            primary: true,
        },
        {
            label: "出入库记录",
            path: "/uld-history",
            icon: <HistoryOutlined />,
            primary: false,
        },
        {
            label: "统计分析",
            path: "/uld-statistics",
            icon: <PieChartOutlined />,
            primary: false,
        },
    ];

    return <QuickAccessWidget title="ULD管理中心" items={items} viewMorePath="/uld-management" showTitle={false} showMenu={false} {...props} />;
};

export default UldQuickAccessWidget;
